export default __webpack_public_path__ + "static/803-ba4c71fee72a6c7210d3a15f42abaffc.gif";